import styled from "styled-components";

const InsideContent = styled.div`

height: 100%;
width:90%;

`

export default InsideContent;